<template>
  <Modal max-width="400" title="Ativar Certificado SSL" title-section-mobile="Ativar Certificado SSL" controlsDirection="right">
    <p class="text-caption">Deseja seguir com a ativação do certificado SSL no site sitedocliente.tld?</p>
    <template #append>
      <Button color="primary" text label="Talvez outra hora" @click="toggleModal"/>
      <Button color="primary" class="ml-2" label="Ativar SSL" @click="enableSsl"/>
    </template>
  </Modal>
</template>

<script>
import { Button, Modal } from '@locaweb/design-system-vue'
import { enableSecurity } from '@/views/site/api/site.api'
export default {
  components: { Button, Modal },
  props: ['site'],
  methods: {
    toggleModal () {
      this.$emit('closeSsl')
    },
    async enableSsl () {
      const wordpressId = this.site.wordpress_id
      enableSecurity(wordpressId)
      this.$emit('enableSsl')
    }
  }
}
</script>
